import { useLocale } from "@calcom/lib/hooks/useLocale";
import { IOnboardingComponentProps } from "pages/onboarding/[[...step]]";

const OPTIONS = [
  { value: "jojo", label: "lb_onboarding_hurdle_option_1" },
  { value: "stress", label: "lb_onboarding_hurdle_option_2" },
  { value: "motivation", label: "lb_onboarding_hurdle_option_3" },
];

export const HurdleStep = ({ nextStep, handleSaveAnswer }: IOnboardingComponentProps) => {
  const { t } = useLocale();

  const handleSelect = (value: string) => {
    handleSaveAnswer("hurdle", value);
    nextStep();
  };

  return (
    <div className="flex flex-col gap-3">
      {OPTIONS.map((opt, index) => (
        <button
          key={opt.value}
          type="button"
          onClick={() => handleSelect(opt.value)}
          className="text-brand-800 border-brand-900 animate-fade-in-up  w-full rounded-lg border  bg-gray-100 px-5 py-4 text-left text-sm font-[600] opacity-0 transition-all"
          style={{ animationDelay: `${index * 100}ms`, animationFillMode: "forwards" }}>
          {t(opt.label)}
        </button>
      ))}
    </div>
  );
};
